import type { OrderLiveEntity } from './OrderLiveEntity'

export class OrderLiveResponseEntity {
  showCompletedOrderDurationInSecond?: number
  showCanceledOrderDurationInSecond?: number
  orders?: Array<OrderLiveEntity> | null
}
